import { CHAIN_IDS } from "@src/components/DefuseSDK/constants/evm"
import type { ContactNetwork } from "@src/components/DefuseSDK/features/contacts/utils/contactNetwork"
import type { FreshDestinationInput } from "@src/components/DefuseSDK/services/destinationFreshnessService"
import type { FreshnessTelemetryPayload } from "@src/components/DefuseSDK/services/emitter"
export type { FreshDestinationInput }

export function freshDestinationKey(input: FreshDestinationInput): string {
  return `${input.rail}:${input.chain}:${input.recipient.toLowerCase()}`
}

export function freshDestinationInput({
  network,
  recipient,
}: {
  network: ContactNetwork
  recipient: string | null | undefined
}): FreshDestinationInput | null {
  if (network === "near_intents" || recipient == null || recipient === "") {
    return null
  }

  if (CHAIN_IDS[network] == null) {
    return null
  }

  return { rail: network, chain: network, recipient }
}

export function freshDestinationTelemetryPayload(
  input: FreshDestinationInput,
  overridden: boolean
): FreshnessTelemetryPayload {
  return {
    chain: input.chain,
    rail: input.rail,
    fresh: true,
    overridden,
  }
}
